<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="lostPaymentList"
				:flag="flag"
				page-title="Company expenses"
				:headers="headers"
				:settings="getSettings"
				:filtersList="lostPaymentFilters"
				:list="lostPaymentList"
				:defaultOrder="lostPaymentOrder"
				:defaultSort="lostPaymentSort"

				:totals="lostPaymentTotals"
				:total-pages="lostPaymentTotal"
				:limit-pages="lostPaymentLimit"
				:pages="[ 20, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				:isExport="isExport()"
				is-export-permissions
				:is-create="false"
				is-settings
		></main-table-all-back>
		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('lost-payment')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

		<preload v-if="isPreloader"></preload>

	</div>
</template>

<script>
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack.vue";
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
import { mapActions, mapGetters } from "vuex";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import Preload from "@/shared/Preload/Preload.vue";
import { TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import { PAGE, PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "LostPayment",
	mixins: [ settingsMixins, removeMixins ],
	components: {
		Preload,
		DialogRemove,
		MainTableAllBack,
	},
	computed: mapGetters([
		"lostPaymentList",
		"lostPaymentFilters",
		"lostPaymentTotals",
		"permissions",
		"permissionsDefault",
		"lostPaymentOrder",
		"lostPaymentLimit",
		"lostPaymentSort",
		"lostPaymentTotal",
		"previewLink",
	]),
	data: () => ({
		flag: PAGE.LOST_PAYMENTS,
		isLostPaymentForm: false,
		driverId: null,
		defaultFilter: null,
		activeTableFilters: null,
		isPreloader: false,
		activeItem: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
	}),
	methods: {
		...mapActions([ 'getLostPayment', 'getLostPaymentFilters', 'actionPreloader', 'onExportLink', 'deleteLostPayment' ]),
		onCloseDialog(isRefresh) {
			this.isLostPaymentForm = false;
			if (isRefresh) {
				this.onUpdateFilters(this.defaultFilter);
			}
		},

		async onEvent(flag) {
			if (flag === 'create') {
				this.isLostPaymentForm = true;
				this.driverId = null;
			}
		},
		async onUpdateFilters(filters, isWithoutFilters) {
			await this.getLostPayment(filters);
			if (!isWithoutFilters) await this.getLostPaymentFilters(filters);
		},
		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getLostPayment(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'lost-payment' });
		},
		isExport() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNTING, PERMISSIONS.LOST_PAYMENTS, PERMISSIONS.EXPORT ];
			return getPermissionsMod({ list, path });
		},
		async onClickButton({ key, item }) {
			this.activeItem = item;

			if ( key === 'delete' ) {
				const title = TITLE.REMOVE_LOST_PAYMENTS;
				const text = TEXT.REMOVE_LOST_PAYMENTS;
				this.onRemoveDialog({ title, text });
			}
		},

		async onRemove() {
			const { id } = this.activeItem;
			await this.deleteLostPayment(id);
			this.onCloseRemove();
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},

	},
	async mounted() {
		await this.onUpdateFilters();
	}
};
</script>

<style scoped lang="scss"></style>
